import { render, staticRenderFns } from "./DistributorField.vue?vue&type=template&id=70d2522a&scoped=true"
import script from "./DistributorField.vue?vue&type=script&setup=true&lang=ts"
export * from "./DistributorField.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d2522a",
  null
  
)

export default component.exports